<template>
  <v-container class="fill-height">
    <div v-if="isLoading" justify="center" align="center">
      <v-col class="12">
        <v-progress-circular indeterminate color="purple"></v-progress-circular>
      </v-col>
      <v-col class="12">
        <p>Iniciando sesión. Por favor espere...</p>
      </v-col>
    </div>

    <v-row v-else-if="!isLoading" justify="center" align="center">
      <v-col cols="10" v-if="success">
        <v-alert outlined type="success" text>
          <h2 class="text-h5 mb-5 text-center">
            Inicio de sesión exitoso
          </h2>
          <p class="mt-5 text-paragraph text-center">
            Redirigiendo...
          </p>
        </v-alert>
      </v-col>
      <v-col cols="10" v-else>
        <v-alert outlined type="error" text>
          <!-- <h2 class="text-h5 mb-5 text-center">
            No iniciar sesión
          </h2> -->
          <p class="mt-5 text-paragraph text-center">
            {{ errorMessage }}
          </p>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { PbxHttpClient } from "@/services/httpclient";

export default {
  data() {
    return {
      isLoading: true,
      token: "",
      errorMessage: "El proceso de verificacion ha fallado, por favor intente nuevamente",
      success: false,
    };
  },

  mounted() {
    this.token = this.$route.params.token;
    this.verifyToken();
  },

  methods: {
    async verifyToken() {
      this.isLoading = true;

      try {
        const res = await this.$store.dispatch("passport/AUTHENTICATE", {
          token: this.token,
        });
        // console.log("hoola");
        // console.log("data", res);

        this.success = true;

        switch (res.role_id) {
          case 3:
            this.$router.push({ name: "Bienvenido" });
            break;
          case 4:
            this.$router.push({ name: "WhatsApp" });
            break;

          default:
            this.$router.push({ name: "Home" });
            break;
        }
      } catch (err) {
        this.errorMessage = err.response.data.message;
        this.$snotify.error(err.response.data.message, "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
